import { render, staticRenderFns } from "./CorpBusiness.vue?vue&type=template&id=7fefdf93"
import script from "./CorpBusiness.vue?vue&type=script&lang=js"
export * from "./CorpBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports